import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServiceCards from './components/ServiceCards';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import DreamReviewSection from './components/DreamReviewSection';
import AstrologyReviewSection from './components/AstrologyReviewSection';
import SEOSchema from '../../components/feature/SEOSchema';
import PricingSection from './components/PricingSection';
import FAQSection from './components/FAQSection';

const siteUrl = 'https://destinygpt.com';

const homeSchema = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${siteUrl}/#website`,
      url: `${siteUrl}/`,
      name: '데스티니GPT',
      alternateName: ['Destiny GPT', '데스티니AI 포춘', 'DestinyGPT'],
      description: 'AI 점성술·사주팔자·꿈해몽 운세 서비스. 데스티니AI 포춘으로 탄생 차트와 평생 운세 리포트를 즉시 제공합니다.',
      inLanguage: 'ko-KR',
      potentialAction: {
        '@type': 'SearchAction',
        target: `${siteUrl}/celebrity-saju?q={search_term_string}`,
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'SoftwareApplication',
      '@id': `${siteUrl}/#app`,
      name: '데스티니GPT — 데스티니AI 포춘',
      alternateName: ['Destiny GPT', '데스티니AI 포춘'],
      applicationCategory: 'LifestyleApplication',
      operatingSystem: 'Web',
      url: `${siteUrl}/`,
      description: 'AI 점성술과 사주팔자 분석으로 탄생 차트·평생 운세 리포트를 제공하는 데스티니AI 포춘 서비스.',
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'KRW',
        description: '무료 체험 제공',
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.9',
        reviewCount: '12400',
        bestRating: '5',
      },
    },
    {
      '@type': 'Organization',
      '@id': `${siteUrl}/#organization`,
      name: '데스티니GPT',
      alternateName: 'Destiny GPT',
      url: `${siteUrl}/`,
      description: '데스티니AI 포춘 — AI 점성술, 사주팔자, 꿈해몽 운세 서비스',
      sameAs: [],
    },
    {
      '@type': 'WebPage',
      '@id': `${siteUrl}/#webpage`,
      url: `${siteUrl}/`,
      name: '데스티니GPT | AI 점성술·사주 운세 · 데스티니AI 포춘 1위 서비스',
      description:
        '데스티니GPT(Destiny GPT) — 데스티니AI 포춘으로 AI 점성술·사주팔자·꿈해몽을 한곳에서. 생년월일을 입력하면 탄생 차트와 평생 운세 리포트를 즉시 받아보세요.',
      isPartOf: { '@id': `${siteUrl}/#website` },
      publisher: { '@id': `${siteUrl}/#organization` },
      inLanguage: 'ko-KR',
      dateModified: '2026-03-17',
    },
    {
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '데스티니GPT(Destiny GPT)란 무엇인가요?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '데스티니GPT(Destiny GPT)는 AI 기반 점성술·사주팔자·꿈해몽 운세 분석 서비스인 데스티니AI 포춘 플랫폼입니다. 생년월일과 출생 시간을 입력하면 탄생 차트와 평생 운세 리포트를 즉시 받아볼 수 있습니다.',
          },
        },
        {
          '@type': 'Question',
          name: '데스티니AI 포춘은 무료로 이용할 수 있나요?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '데스티니AI 포춘은 첫 분석을 무료로 제공합니다. 탄생 정보를 입력하면 AI가 즉시 점성술·사주 운세를 분석해드립니다.',
          },
        },
        {
          '@type': 'Question',
          name: '데스티니 GPT에서 점성술과 사주팔자를 모두 분석해주나요?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '네, 데스티니 GPT는 동양의 사주팔자(四柱八字)와 서양 점성술을 통합 분석합니다. 데스티니AI 포춘 서비스를 통해 더욱 정확한 운세 정보를 제공합니다.',
          },
        },
        {
          '@type': 'Question',
          name: '데스티니 GPT 결정 비서는 어떤 서비스인가요?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '데스티니 GPT 결정 비서는 직장 전환, 결혼, 이사, 창업, 투자 등 인생의 중대한 결정을 사주(四柱)와 오행(五行)으로 최적의 시기와 방향을 분석해드리는 AI 운세 서비스입니다.',
          },
        },
        {
          '@type': 'Question',
          name: '점성술 탄생 차트는 어떻게 분석하나요?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '데스티니AI 포춘의 점성술 서비스는 생년월일·출생 시간·출생지를 기반으로 별자리와 행성 배치를 계산하여 탄생 차트를 작성하고, AI가 심층 운세 리포트를 제공합니다.',
          },
        },
        {
          '@type': 'Question',
          name: '평생 운세 리포트는 무엇을 포함하나요?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '데스티니GPT 평생 운세 리포트는 사주팔자 기반 대운·세운 분석, 점성술 탄생 차트, 연애·직업·건강·재물 운세를 포함하며, 데스티니AI 포춘이 PDF 형태로 제공합니다.',
          },
        },
      ],
    },
  ],
};

export default function HomePage() {
  return (
    <div className="min-h-screen bg-cosmic-gradient">
      <SEOSchema schema={homeSchema} id="home-schema" />
      <Navbar />
      
      <main>
        <HeroSection />
        <AstrologyReviewSection />
        <ServiceCards />
        <PricingSection />
        <FAQSection />
        <DreamReviewSection />
        <TestimonialSection />
        <CTASection />
      </main>

      <Footer />
    </div>
  );
}
